<template>
  <div class="apj-page-banner">
    <div class="text-container" >
      <div class=" pi-fw-600 title animate__animated animate__fadeInDown" v-if="options.title">{{ options.title }}</div>
      <div class="title-sub" v-if="options.subTitle">
        {{ options.subTitle }}
      </div>
      <div class="text" v-if="options.text">{{ options.text }}</div>
    </div>
    <!-- <img  :src="options.banner" class="pi-w-100vw"/> -->
    <el-image :src="options.banner" fit="cover" @load='show=true' style="width:100vw"></el-image>
  </div>
</template>

<script>
import { isMobile } from "@/utils";
export default {
  name: "apj-page-banner",
  data(){
    return{
      isMobile: isMobile(),
      show:false
    }
  },

  props: {
    // banner: {
    //   type: String,
    //   defeult: require("@/assets/images/banner/service.jpg")
    // },


    // show: {
    //   type: Boolean,
    //   default: true,
    // },
    options: {
      type: Object,
      defeult() {
        return {
          banner: require("@/assets/images/banner/service.jpg"),
          title: "",
          text: "",
          subTitle: "",
        };
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    trigger(eventName) {
      //   console.log("trigger(eventName) ... " , eventName);
      if (!eventName) {
        console.error("event name not allow null.");
        return;
      }
      if (!this[eventName]) {
        console.error("event not found.");
        return;
      }
      this[eventName]();
    },
  },
};
</script>


<style lang="scss" scoped>
@import url("https://at.alicdn.com/t/font_2425752_agu6ou9vlug.css");
@import "@/assets/theme.scss";

/**  replace element css */
.el-backtop {
  position: initial;
}

/** apj-page-banner */
$banner-height: 520px;
.apj-page-banner {
  height: $banner-height;
  min-height: $banner-height;
  max-height: $banner-height;
  position: relative;
  .el-image {
    z-index: 1;
    display: block;
    position: absolute;
    width: auto;
    height: 100%;
  }

  .text-container {
    z-index: 2;
    position: absolute;
    width: 100%;
    height: 100%;
    color: $color-text-white;
    // background-color: red;
    padding: 70px;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;

    > div {
      color: $color-text-white;
      line-height: 2em;
    }
    .title {
      font-size: 40px;
    }
    .text {
      font-size: 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/apj-page-banner/index.vue